module.exports = __webpack_public_path__ + "img/up.38d5638b.svg";